import { render, staticRenderFns } from "./InvoiceAccounting.vue?vue&type=template&id=1aee9d04&"
import script from "./InvoiceAccounting.vue?vue&type=script&lang=ts&"
export * from "./InvoiceAccounting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports